var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftNavigator = function SvgLeftNavigator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LeftNavigator_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M23 .96v23H0v-23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#070425",
    d: "M16.688 20.69 8.46 12.46l8.228-8.227a1.916 1.916 0 0 0-2.71-2.71l-9.583 9.583a1.917 1.917 0 0 0 0 2.71l9.583 9.583a1.917 1.917 0 1 0 2.71-2.71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LeftNavigator_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23 .96v23H0v-23z"
  })))));
};
export { SvgLeftNavigator as ReactComponent };